import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

const Content = lazy(async () => {
  const loaded = await import(/* webpackChunkName: 'activityLog' */'./page')
  return { default: loaded.Page }
})

export const ActivityLog = withSafeSuspense(Content)
